import { http } from './http';

export function getCatalog(params = {}) {
  return http.get('/api/v1/catalog', { params }).then((r) => r.data);
}

export function getTopCatalog(params = {}) {
  return http.get('/api/v1/catalog/top', { params }).then((r) => r.data);
}
